import { Form, Checkbox, DatePicker, Col, Row } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import InputDecimal from '../../InputDecimal';
import SectionCard from '../../SectionCard';

interface Props {
  prefixPath?: string[];
}

export default function CompetencyAdjustmentFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  const form = Form.useFormInstance();
  const enableAjusteCompet = Form.useWatch('enableAjusteCompet', form);

  return (
    <>
      {/* ===== Ajuste de Competência (UB112..UB114) ===== */}
      <div>
        <Form.Item name="enableAjusteCompet" valuePropName="checked">
          <Checkbox style={{ fontWeight: 600 }}>
            Exibir Grupo Ajuste de Competência
          </Checkbox>
        </Form.Item>
      </div>

      <SectionCard visible={enableAjusteCompet} title="Ajuste de Competência">
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Período de Apuração (MM-AAAA)"
              // rules={[requiredField]}
              name={[...prefixPath, 'competenceApuration']}
            >
              <DatePicker.MonthPicker
                format="MM/YYYY"
                style={{ width: '100%' }}
                placeholder=""
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor IBS"
              name={[...prefixPath, 'competenceIbsValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor CBS"
              name={[...prefixPath, 'competenceCbsValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>
    </>
  );
}
